import { checkActivityFunctions } from "single-spa";
import { languages } from "../locale";
import { lang } from "./locale.helpers";
const APPS_SECTION_CLASSNAME = "apps-section_white";
export const APPS_SECTION_ID = "#apps-section";
const MAIN_CONTAINER_SELECTOR = ".main-container";
const MAIN_CONTAINER_FULL_WIDTH_CLASSNAME = "main-container_full-width";
export function hideLoader() {
    const el = document.querySelector("#loading");
    el.classList.add("hidden");
    setTimeout(() => el.style.setProperty("display", "none"), 300);
}
export function setAppTitle() {
    const nodes = document.getElementsByClassName("moex-platform-title") || [];
    const images = document.getElementsByClassName("moex-platform-title-img") || [];
    if (nodes && nodes.length) {
        for (const el of nodes) {
            el.innerText = languages[lang].appName;
        }
    }
    if (images && images.length) {
        for (const el of images) {
            el.src = `/img/moex-logo-${lang}.svg`;
            el.alt = languages[lang].appName;
        }
    }
}
export function show404Error() {
    const persistentApps = ["@platform/mb-app-header", "@platform/mb-app-footer"];
    const errorBlock = document.getElementById("app-load-error");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const appsThatShouldBeActive = checkActivityFunctions();
    const onlyPersistentApps = appsThatShouldBeActive.every((app) => persistentApps.includes(app));
    setTimeout(() => {
        if (onlyPersistentApps && location.pathname !== "/" && errorBlock) {
            errorBlock.innerHTML = `<div class="error-flex"><img src="/img/404.png" /><div class="error-block"><p class="error-title">${languages[lang].pageNotExist}</p><a class="pl-primary-btn error-btn-back" href="/" onclick="singleSpaNavigate(event)">${languages[lang].goBackHome}</a></div></div>`;
        }
    }, 700);
}
export function checkWidth(applicationsList) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const appsThatShouldBeActive = checkActivityFunctions();
    Object.keys(applicationsList).some((app) => {
        if (appsThatShouldBeActive.includes(`@platform/${app}`) &&
            applicationsList[app].config &&
            applicationsList[app].config.fullWidth) {
            hideAppsContainer();
            expandMainContainer();
        }
    });
}
export function showAppsContainer() {
    const container = document.querySelector(APPS_SECTION_ID);
    container?.classList?.add(APPS_SECTION_CLASSNAME);
}
export function hideAppsContainer() {
    const container = document.querySelector(APPS_SECTION_ID);
    container?.classList?.remove(APPS_SECTION_CLASSNAME);
}
export function expandMainContainer() {
    const container = document.querySelector(MAIN_CONTAINER_SELECTOR);
    container?.classList?.add(MAIN_CONTAINER_FULL_WIDTH_CLASSNAME);
}
export function collapseMainContainer() {
    const container = document.querySelector(MAIN_CONTAINER_SELECTOR);
    container?.classList?.remove(MAIN_CONTAINER_FULL_WIDTH_CLASSNAME);
}
